import { render, staticRenderFns } from "./DetectionArea.vue?vue&type=template&id=15666ed2&scoped=true"
import script from "./DetectionArea.vue?vue&type=script&lang=js"
export * from "./DetectionArea.vue?vue&type=script&lang=js"
import style0 from "./DetectionArea.vue?vue&type=style&index=0&id=15666ed2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15666ed2",
  null
  
)

export default component.exports